import { useMutation } from '@apollo/client'

import { SetUserPinParams } from '@flowwai-frontend/bps-officer-web/graphql'
import {
   convertToErrorType,
   CustomError,
   getAPIStatus
} from '@flowwai-frontend/shared-web/common/data-access'
import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'

import {
   SetUserPinMutation as Mutation,
   SetUserPinDocument as MutationDocument,
   SetUserPinMutationVariables as MutationVariables
} from './mutation.generatedTypes'
import useAPIResponseHandler from './responseHandler'

export interface FailureArgsType {
   data?: CustomError<Mutation['setUserPin']>
   error?: Error | null
}

interface TriggerAPIArgsType {
   requestObj: SetUserPinParams
   onFailure?: (args: FailureArgsType) => void
   onSuccess?: (userPIN: UserPIN) => void
}

export const useSetUserSigningPin = () => {
   const [setUserPin, { error, loading }] = useMutation<
      Mutation,
      MutationVariables
   >(MutationDocument)

   const { handleAPIResponse } = useAPIResponseHandler()

   const triggerAPI = (args: TriggerAPIArgsType): void => {
      setUserPin({
         fetchPolicy: 'network-only',
         variables: {
            params: args.requestObj
         },
         onError: error => {
            args.onFailure?.({ error })
         },
         onCompleted: data =>
            handleAPIResponse({
               data,
               onSuccess: args.onSuccess,
               onFailure: (errorMessage, data) =>
                  args.onFailure?.({
                     data: new CustomError(errorMessage, data)
                  })
            })
      })
   }

   const apiError = convertToErrorType(error)

   const apiStatus = getAPIStatus({
      isError: Boolean(error),
      isLoading: loading
   })

   return {
      apiError,
      apiStatus,
      triggerAPI
   }
}
